import { createContext } from "react";

const messagesContext = createContext();
export default messagesContext;